@let $confirmPasswordType = confirmPasswordType();
@let $countRequired = countRequired();
@let $isAdmin = isAnyAdmin();
@let $passwordType = passwordType();
@let $taskHasStarted = taskHasStarted();

<mbs-modal
  [loading]="loading()"
  [title]="$taskHasStarted ? null : ('modal.title.exportPstFile' | i18next: { format: 'capitalize' })">
  <ng-container modal-body>
    @if ($taskHasStarted) {
      <div class="text-center">
        <span
          class="fa fa-check-circle text-success"
          [style]="{ fontSize: '70px' }"></span>
      </div>

      <h3 class="text-center my-2 fw-semibold">
        {{ 'modal.title.exportPstFile' | i18next: { format: 'capitalize' } }}
      </h3>

      <p class="mb-0 text-center">
        {{ 'modal.body.exportPstFile' | i18next: { format: 'capitalize' } }}
      </p>
    } @else {
      @if ($isAdmin) {
        <p>
          {{ 'modal.body.description.exportPstFile_admin.part_1' | i18next: { format: 'capitalize', countRequired: $countRequired } }}
          <span class="fw-semibold">
            {{ 'modal.body.description.directPSTDownloadSettings' | i18next: { format: 'capitalize' } }}
          </span>
          {{ 'modal.body.description.exportPstFile_admin.part_2' | i18next: { format: 'capitalize' } }}
          <span class="fw-semibold"> {{ domainName() }}. </span>
          {{ 'modal.body.description.exportPstFile_admin.part_3' | i18next: { format: 'capitalize' } }}
          <span class="fw-semibold">
            {{ 'modal.body.description.directPSTDownload' | i18next: { format: 'capitalize' } }}
          </span>
          {{ 'modal.body.description.exportPstFile_admin.part_4' | i18next: { format: 'capitalize' } }}
        </p>

        <form [formGroup]="formGroup">
          <mbs-form-group>
            <mbs-input
              mbsAutoFocus
              [appendButtons]="[
                {
                  id: PasswordTypeKey.Base | appendButtonsId,
                  type: 'secondary',
                  icon: $passwordType | appendButtonIcon,
                  btnType: 'button',
                  loading: false,
                  disabled: false
                }
              ]"
              [autocomplete]="'off'"
              [boldLabel]="true"
              [formControlName]="FormKey.Password"
              [label]="'modal.label.passwordForArchivesWithYourData' | i18next: { format: 'capitalize' }"
              [labelClasses]="'text-base'"
              [placeholder]="'modal.placeholder.enterPassword' | i18next: { format: 'capitalize' }"
              [type]="$passwordType"
              (buttonClick)="handleChangePasswordType($event)" />
          </mbs-form-group>

          <mbs-form-group class="mb-0">
            <mbs-input
              [appendButtons]="[
                {
                  id: PasswordTypeKey.Confirm | appendButtonsId,
                  type: 'secondary',
                  icon: $confirmPasswordType | appendButtonIcon,
                  btnType: 'button',
                  loading: false,
                  disabled: false
                }
              ]"
              [autocomplete]="'off'"
              [boldLabel]="true"
              [formControlName]="FormKey.ConfirmPassword"
              [label]="'modal.label.confirmPassword' | i18next: { format: 'capitalize' }"
              [labelClasses]="'text-base'"
              [placeholder]="'modal.placeholder.reEnterPassword' | i18next: { format: 'capitalize' }"
              [type]="$confirmPasswordType"
              (buttonClick)="handleChangePasswordType($event)" />
          </mbs-form-group>
        </form>
      } @else {
        <p class="mb-0">
          {{ 'modal.body.description.exportPstFile_user.part_1' | i18next: { format: 'capitalize', countRequired: $countRequired } }}
          <span class="fw-semibold">
            {{ 'modal.body.description.directPSTDownload' | i18next: { format: 'capitalize' } }}
          </span>
          {{ 'modal.body.description.exportPstFile_user.part_2' | i18next }}
        </p>
      }
    }
  </ng-container>

  <ng-container modalFooter>
    @if ($taskHasStarted) {
      <mbs-button
        [routerLink]="[prefix() + RoutePath.TaskManager]"
        [type]="'primary'"
        (click)="handleClose()">
        {{ moduleButton + ':button.trackExport' | i18next: { format: 'capitalize' } }}
      </mbs-button>
    } @else {
      @if ($isAdmin) {
        <mbs-button
          [disabled]="!formGroup.touched || !formGroup.valid"
          [loading]="buttonLoading()"
          [type]="'primary'"
          (click)="handleSave()">
          {{ moduleButton + ':button.enableDirectPSTDownload' | i18next: { format: 'capitalize' } }}
        </mbs-button>
      }

      <mbs-button (click)="handleClose()">
        {{
          $isAdmin
            ? (moduleButton + ':button.cancel' | i18next: { format: 'capitalize' })
            : (moduleButton + ':button.close' | i18next: { format: 'capitalize' })
        }}
      </mbs-button>
    }
  </ng-container>
</mbs-modal>
